module.exports = __webpack_public_path__ + "media/components/stylesheets/BrandonText-Regular-43e77d5e5d4ae89dda8d5dcd7e2efb4e.woff";